import React, { FC, useCallback, useState } from 'react';
import { Button } from 'react-bootstrap';
import Label from '../label/Label';
import Feedback from '../feedback/Feedback';
import { useIntl } from 'react-intl';

export interface Props {
  onChange: (values: any[]) => void;
  children: any;
  values: any[];
  touched: boolean | undefined;
  error: string | undefined;
  required: boolean | undefined;
  label: string;
}

const MultipleInput: FC<Props> = ({ onChange, children, values, required, label, error, touched }: Props) => {
  const [valuesState, setValuesState] = useState(values);
  const intl = useIntl();

  const onMultipleChange: any = useCallback(
    (value, index) => {
      const newValues = [...valuesState];
      newValues[index] = value;
      const updatedValues = [...newValues];
      setValuesState(updatedValues);
      onChange(updatedValues);
    },
    [valuesState],
  );

  const onMultipleBlur: any = useCallback(
    (value, index) => {
      const newValues = [...valuesState];
      newValues[index] = value;
      const updatedValues = [...newValues];
      setValuesState(updatedValues);
      onChange(updatedValues);
    },
    [valuesState],
  );

  const addValue: any = useCallback(() => {
    const updatedValues = [...valuesState, ''];
    setValuesState(updatedValues);
    onChange(updatedValues);
  }, [valuesState]);

  const removeValue: any = useCallback(
    (index) => {
      const newValues = [...valuesState];
      newValues.splice(index, 1);
      const updatedValues = [...newValues];
      setValuesState(updatedValues);
      onChange(updatedValues);
    },
    [valuesState],
  );

  return (
    <div>
      <div className={`col-md-12 form-group`}>
        <Label required={required} label={label} />
        <div>
          {valuesState.map((value, index) => {
            return (
              <div key={index} className="mb-2">
                <div className="d-flex">
                  <div className="flex-1 me-2">
                    {children({
                      onChange: (updatedValue) => onMultipleChange(updatedValue, index),
                      onBlur: (updatedValue) => onMultipleBlur(updatedValue, index),
                      value,
                      index,
                    })}
                  </div>
                  <Button variant={'danger'} onClick={() => removeValue(index)}>
                    x
                  </Button>
                </div>

                <Feedback touched={touched} error={error ? error[index] : ''} />
              </div>
            );
          })}
          <Button key={'Add Value'} variant={'primary'} onClick={addValue}>
            {intl.formatMessage({ id: 'add' })}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default MultipleInput;
